import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import CardsView from '../CardsView';
import TableView from '../TableView';

import FixedPanel from '../../common/FixedPanel';
import Button from '../../common/Button';
import PageTitle from '../../common/PageTitle';
import Pagination from '../../common/Pagination';

import { fetchEditVariant, fetchGetCommonMaterial } from '../../../actions/items';
import { ITEMS_PAGE_TABS, ITEMS_TYPES } from '../../../config';
import styled from '@emotion/styled';
import InputWrapper from '../../common/InputWrapper';
import Select from '../../common/Select';
import EditLeftoverModal from '../../Modal/EditLeftoverModal';
import { showModal } from '../../../actions/modal';
import { fetchGetAccountInfo } from '../../../actions/auth';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .form-group-search {
    margin-left: -15px;
    width: calc(100% + 15px);
    padding-bottom: 2px;
    margin-top: 19px;
  }

  @media (max-width: 765px) {
    .form-group-search {
      margin-top: 0px;
      margin-left: 0px;
      width: 100%;
    }
  }

  .nav-tab {
    cursor: pointer;
    margin-right: 12px;
  }

  .nav-tab-active {
    font-weight: 700;
    color: #7e57c2;
  }
`;

const ItemsTabsWrapper = styled('div')`
  .nav-tabs-orders {
    position: absolute;
    top: -38px;
  }

  .form-group {
    position: relative;
  }

  .nav-tabs-orders .nav-item.show .nav-link,
  .nav-tabs-orders .nav-link.active {
    color: #7e57c2;
    background-color: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .nav-tabs-orders .nav-link-after {
    content: '';

    left: 0px;
    width: 100%;
    height: 5px;
    background-color: #fff;
    border: none;
  }

  .nav-tabs-orders .nav-link-after {
    border-top: 1px solid #edf0f2;

    margin-top: -1px;
  }

  .nav-tabs-orders .nav-link-after.active {
    border-top: 0px;
    margin-top: 0px;
  }

  .nav-tabs-orders .nav-link.active .badge {
    background-color: #7e57c2;
    color: #fff;
  }

  .nav-tabs-orders .nav-link .badge {
    background-color: #dfe4e6;
    color: #828489;
    margin-left: 10px;
    font-weight: 600;
  }

  .nav-tabs-orders .nav-link .badge {
  }

  .nav-tabs-orders .nav-item {
    margin-right: 4px;
  }

  .nav-tabs-orders .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    background-color: #fbfcfd;
  }

  .nav-tabs-orders .nav-link.active {
    border: 1px solid transparent;
  }

  .nav-tabs-orders .nav-link:hover {
    background-color: #fff;
  }

  .nav-tabs-orders > li > a {
    color: #7a7c82;
    font-weight: 600;
  }

  .nav-link {
    display: block;
    padding: 0.5rem 1rem;
    cursor: pointer;
  }

  .nav-link .nav-link-icon {
    padding-top: 1px;
    margin-right: 3px;
  }

  .nav-link i {
    font-size: 1rem;
    margin-right: 3px;
    margin-top: 4px;
  }

  @media (max-width: 520px) {
    .nav-link {
      padding-right: 5px;
      padding-left: 5px;

      .badge {
        display: none;
      }
    }
  }
`;

const DesktopLayout = (props) => {
  const {
    selectedLength,
    archiveMode,
    exportToFulfillmentLoading,
    data,
    totalItems,
    search,
    barcode,
    tableMode,
    loading,
    currencySymbol,
    items,
    selected,
    selectedAll,
    handleSearch,
    handleSearchByBarcode,
    handleDeliveryModal,
    handleGotoItemPage,
    handleGetItems,
    updateProduct,
    handleToggleMainCheckbox,
    handleToggleCheckbox,
    openVariant,
    state,
    handlePageSelect,
    handlePerPageValue,
    setState,
    handleToggleArchive,
    handleUploadToFulfillment,
    clearSelected,
    getHideBool,
    handleCopyItems,
    handleHideShow,
    handleArchiveItems,
    handleRestoreItems,
    handleUpdateSorting,
    activeTab,
    handleOpenTab,
    types,
    handleTypeItems,
    urlSearchStr,
    skuSets,
    sorting,
  } = props;

  const dispatch = useDispatch();
  const [commonMaterialData, setCommonMaterialData] = useState([]);
  const [isMaterials, setIsMaterials] = useState(false);

  const { t } = useAutoTranslation();

  const handleLeftoverModal = () => {
    dispatch(showModal('EditLeftoverModal', {}));
  };

  const handlePackagingShipmentReportModal = () => {
    dispatch(showModal('PackagingReportModal', {}));
  };

  const { account } = useSelector((state) => state.auth);

  const NEW_ITEMS_PAGE_TABS = ITEMS_PAGE_TABS.slice(0, ITEMS_PAGE_TABS.length - 1); // Не отображаем последнюю вкладку

  return (
    <Wrapper>
      <FixedPanel show={selectedLength}>
        <div className="fixed-panel-inner">
          <div className="mb-2">
            <div>
              {t('Выбрано товаров')}: {selectedLength}
            </div>
            <div className="clear-selected">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  clearSelected();
                }}
              >
                {t('Снять выделение')}
              </a>
            </div>
          </div>
          <div className="buttons-block">
            {!archiveMode ? (
              <>
                <Button
                  className="mb-2 mr-2"
                  type="button"
                  text={t('Выгрузить на фулфилмент')}
                  icon="fe-arrow-down"
                  disabled={exportToFulfillmentLoading}
                  loading={exportToFulfillmentLoading}
                  onClick={() => handleUploadToFulfillment()}
                />
                <button
                  className="btn btn-primary waves-effect waves-light mb-2 mr-2"
                  onClick={() => handleCopyItems()}
                >
                  <i className="fe-copy" /> <span>{t('Копия')}</span>
                </button>
                <button
                  className="btn btn-primary waves-effect waves-light mb-2 mr-2"
                  onClick={() => handleHideShow(data)}
                >
                  <i className={getHideBool(data) ? 'fe-eye-off' : 'fe-eye'} />{' '}
                  <span>{getHideBool(data) ? t('Скрыть') : t('Отобразить')}</span>
                </button>
                <button
                  className="btn btn-primary waves-effect waves-light mb-2 mr-2"
                  onClick={() => handleArchiveItems()}
                >
                  <i className="fe-archive" /> <span>{t('В архив')}</span>
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary waves-effect waves-light mb-2 mr-2"
                onClick={() => handleRestoreItems()}
              >
                <i className="mdi mdi-archive mr-1" /> <span>{t('Восстановить')}</span>
              </button>
            )}
          </div>
        </div>
      </FixedPanel>

      <PageTitle
        title={!archiveMode ? t('Товары') : t('Архив товаров')}
        extraStr={`${t(`Всего товаров`)}: ${totalItems.toString()}`} //${t('шт') - плохой перевод CN, "шт" убраны везде
      />

      <div className="row mt-4">
        <div className="col-12">
          <ItemsTabsWrapper>
            <ul className="nav nav-tabs-orders">
              {NEW_ITEMS_PAGE_TABS?.map((tab) => (
                <li className="nav-item" key={tab.id}>
                  <div
                    data-toggle="tab"
                    aria-expanded="true"
                    className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => handleOpenTab(tab)}
                  >
                    <div className="d-flex flex-row">
                      <div className="tab-title">{t(tab.title)}</div>
                    </div>
                  </div>
                  <div className={`nav-link-after ${activeTab === tab.id ? 'active' : ''}`} />
                </li>
              ))}
              {account.usePackingMaterials === true && (
                <li className="nav-item" key="boxes">
                  <div
                    data-toggle="tab"
                    aria-expanded="true"
                    className={`nav-link ${
                      activeTab === 'consumables_boxes' ||
                      activeTab === 'consumables_other' ||
                      activeTab === 'consumables_attachment' ||
                      activeTab === 'common_materials'
                        ? 'active'
                        : ''
                    }`}
                    onClick={() =>
                      handleOpenTab({
                        id: 'consumables_boxes',
                        title: t('Расходные материалы и допвложения'),
                      })
                    }
                  >
                    <div className="d-flex flex-row">
                      <div className="tab-title">{t('Расходные материалы и допвложения')}</div>
                    </div>
                  </div>
                  <div
                    className={`nav-link-after ${
                      activeTab === 'consumables_boxes' ||
                      activeTab === 'consumables_other' ||
                      activeTab === 'consumables_attachment' ||
                      activeTab === 'common_materials'
                        ? 'active'
                        : ''
                    }`}
                  />
                </li>
              )}
            </ul>
          </ItemsTabsWrapper>
          <div className="card">
            <div className="card-body">
              <div className="row mb-2 d-flex align-items-end justify-content-between">
                <div className="col-xl-8 col-12">
                  {(activeTab === 'consumables_boxes' ||
                    activeTab === 'consumables_other' ||
                    activeTab === 'consumables_attachment' ||
                    activeTab === 'common_materials') && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-inline" style={{ marginBottom: '12px' }}>
                          <span
                            onClick={() =>
                              handleOpenTab({
                                id: 'consumables_boxes',
                                title: t('Расходные материалы и допвложения'),
                              })
                            }
                            className={
                              activeTab === 'consumables_boxes'
                                ? 'nav-tab nav-tab-active'
                                : 'nav-tab'
                            }
                          >
                            {t('Упаковочные короба')}
                          </span>
                          <span
                            onClick={() =>
                              handleOpenTab({
                                id: 'consumables_other',
                                title: t('Другие виды расходных материалов'),
                              })
                            }
                            className={
                              activeTab === 'consumables_other'
                                ? 'nav-tab nav-tab-active'
                                : 'nav-tab'
                            }
                          >
                            {t('Другие виды расходных материалов')}
                          </span>
                          <span
                            onClick={() =>
                              handleOpenTab({
                                id: 'consumables_attachment',
                                title: t(`Допвложения для упаковки`),
                              })
                            }
                            className={
                              activeTab === 'consumables_attachment'
                                ? 'nav-tab nav-tab-active'
                                : 'nav-tab'
                            }
                          >
                            {t(`Допвложения для упаковки`)}
                          </span>
                          <span
                            onClick={() =>
                              handleOpenTab({
                                id: 'common_materials',
                                title: t('Общие материалы'),
                              })
                            }
                            className={
                              activeTab === 'common_materials'
                                ? 'nav-tab nav-tab-active'
                                : 'nav-tab'
                            }
                          >
                            {t('Общие материалы')}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <InputWrapper
                          className="form-control search-input"
                          label={t('Поиск')}
                          type="text"
                          placeholder={t('Поиск')}
                          value={search}
                          onChange={(e) => handleSearch(e.target.value)}
                          icon="fe-search"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group form-group-search">
                        <InputWrapper
                          className="form-control search-input"
                          type="text"
                          placeholder={t('Штрихкод')}
                          value={barcode}
                          onChange={(e) => handleSearchByBarcode(e.target.value)}
                          icon="mdi mdi-barcode-scan"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      {activeTab === 'all' && (
                        <div className="form-group">
                          <Select
                            label={t('Тип товаров')}
                            id="types"
                            options={ITEMS_TYPES}
                            value={types}
                            onChange={(value) => handleTypeItems(value)}
                            isMulti
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="text-xl-right">
                    {(activeTab == 'all' || activeTab == 'items') && (
                      <button
                        type="button"
                        className="btn btn-danger waves-effect waves-light mb-2 mr-2"
                        onClick={() => handleGotoItemPage(null, 'SKU')}
                      >
                        <i className="fe-plus" />
                        {t('Новый товар')}
                      </button>
                    )}
                    {activeTab == 'sets' && (
                      <button
                        type="button"
                        className="btn btn-danger waves-effect waves-light mb-2 mr-2"
                        onClick={() => handleGotoItemPage(null, 'PHYSICAL_SET')}
                      >
                        <i className="fe-plus" />
                        {t('Новый комплект')}
                      </button>
                    )}
                    {activeTab == 'virtualSets' && (
                      <button
                        type="button"
                        className="btn btn-danger waves-effect waves-light mb-2 mr-2"
                        onClick={() => handleGotoItemPage(null, 'BUNDLE')}
                      >
                        <i className="fe-plus" />
                        {t('Новый виртуальный набор')}
                      </button>
                    )}
                    {activeTab === 'consumables_boxes' && (
                      <button
                        type="button"
                        className="btn btn-danger waves-effect waves-light mb-2 mr-2"
                        onClick={() => handleGotoItemPage(null, 'PACKING_MATERIAL_OTHER')}
                      >
                        <i className="fe-plus" />
                        {t('Новый расходный материал')}
                      </button>
                    )}
                    <button
                      type="button"
                      className={`btn mb-2 ml-xl-2 ${archiveMode ? 'btn-secondary' : 'btn-light'}`}
                      onClick={() => handleToggleArchive()}
                    >
                      <i className="fe-archive" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div></div>
                <div className="col-md-8">
                  <div className="form-inline">
                    <div className="form-group mr-2 mb-2">
                      <Link className="btn btn-light" to="/imports">
                        <i className="fe-arrow-up" />
                        {t('Импорт')}
                      </Link>
                    </div>
                    <div className="form-group mr-2 mb-2">
                      <button className="btn btn-light" onClick={() => handleDeliveryModal()}>
                        <i className="fe-arrow-down" />
                        {t('Экспорт')}
                      </button>
                    </div>
                    <div className="form-group mr-2 mb-2">
                      <button className="btn btn-light" onClick={() => handleLeftoverModal()}>
                        {t('Остатки на дату')}
                      </button>
                    </div>
                    {account.usePackingMaterials && activeTab === 'consumables_boxes' ? (
                      <div className="form-group mr-2 mb-2">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => handlePackagingShipmentReportModal()}
                        >
                          {t('Расход упаковки')}
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-md-right">
                    <div className="btn-group mb-2">
                      <button
                        type="button"
                        className={`btn ${tableMode ? 'btn-secondary' : 'btn-light'}`}
                        onClick={() => setState({ tableMode: true })}
                      >
                        <i className="fe-list" />
                      </button>
                      <button
                        type="button"
                        className={`btn ${!tableMode ? 'btn-secondary' : 'btn-light'}`}
                        onClick={() => setState({ tableMode: false })}
                      >
                        <i className="fe-grid" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {!tableMode ? (
                <CardsView
                  loading={loading}
                  data={data}
                  currencySymbol={currencySymbol}
                  onItemClick={(item) => handleGotoItemPage(item)}
                />
              ) : (
                <TableView
                  loading={loading}
                  data={isMaterials ? commonMaterialData : data}
                  currencySymbol={currencySymbol}
                  search={search}
                  items={items}
                  selected={selected}
                  selectedAll={selectedAll}
                  archiveMode={archiveMode}
                  getItems={(data) => handleGetItems(data)}
                  onItemClick={(item) => handleGotoItemPage(item)}
                  fetchEditVariant={(data) => dispatch(fetchEditVariant(data))}
                  updateProduct={(productId) => updateProduct(productId)}
                  handleToggleMainCheckbox={() => handleToggleMainCheckbox()}
                  handleToggleItemVariants={(item) => this.handleToggleItemVariants(item)}
                  handleToggleCheckbox={(id) => handleToggleCheckbox(id)}
                  openVariant={openVariant}
                  updateSorting={(data) => handleUpdateSorting(data)}
                  urlSearchStr={urlSearchStr}
                  skuSets={skuSets}
                  updatedSorting={sorting}
                  t={t}
                />
              )}
              <Pagination
                withPerPageCountSelect
                appStateKey="productsPage"
                total={totalItems}
                currentPage={Number(state.page)}
                perPage={Number(state.size)}
                onPageSelect={(pageIndex) => handlePageSelect(pageIndex)}
                onPerPageSelect={(perPageValue) => handlePerPageValue(perPageValue)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default DesktopLayout;
